import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './empty-state.styles';
interface EmptyStateProps {
  icon?: ComponentChildren;
  title: string;
  message?: string;
  action?: ComponentChildren;
}
export function EmptyState({
  icon,
  title,
  message,
  action
}: EmptyStateProps) {
  return <div {...stylex.props(styles.empty)}>
      {icon != null && <div {...stylex.props(styles.icon)}>{icon}</div>}
      <div {...stylex.props(styles.title)}>{title}</div>
      {message != null && <div {...stylex.props(styles.message)}>{message}</div>}
      {action != null && <div {...stylex.props(styles.action)}>{action}</div>}
    </div>;
}